import { supabase } from '@/lib/supabase';
import { MAX_PATHS } from '../../../supabase/functions/portal-media/request';

export type PortalKind = 'share' | 'contractor';

/**
 * Signed URLs for a portal's stored images, keyed by storage path.
 *
 * Portals are anonymous, so no storage rule can sign these (0032 removed the
 * open ones). The portal-media Edge Function checks the link's token and signs
 * only the files that link's portal shows. Paths it won't sign are simply
 * absent from the result.
 */
export async function signPortalMedia(
  kind: PortalKind, token: string, paths: string[],
): Promise<Record<string, string>> {
  const unique = [...new Set(paths)];
  const urls: Record<string, string> = {};
  for (let i = 0; i < unique.length; i += MAX_PATHS) {
    const { data, error } = await supabase.functions.invoke('portal-media', {
      body: { kind, token, paths: unique.slice(i, i + MAX_PATHS) },
    });
    if (error) throw error;
    Object.assign(urls, (data as { urls?: Record<string, string> } | null)?.urls ?? {});
  }
  return urls;
}
